/* tslint:disable:jsx-no-lambda WI:47690 */
import { owaSuiteHeaderRendered } from '../actions/owaSuiteHeaderRendered';
import { IO365ShellShim } from '@suiteux/suiteux-shell';
import '@suiteux/suiteux-shell';
import { observer } from 'mobx-react';
import setAppPaneUnderlayVisibility from 'owa-application/lib/actions/setAppPaneUnderlayVisibility';
import { getBposNavBarData } from 'owa-bpos-store';
import { getPackageBaseUrl } from 'owa-config';
import { OpenAnotherMailboxDialog } from 'owa-explicit-logon';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { isFeatureEnabled } from 'owa-feature-flags';
import { HEADER_BUTTONS_REGION_ID } from 'owa-header';
import { signout } from 'owa-header/lib/actions/signout';
import { getMergedNotificationPane } from 'owa-header/lib/components/Header';
import { handleSocPostMessageEvents } from 'owa-help-charm';
import loc from 'owa-localize';
import { feedbackLink } from 'owa-locstrings/lib/strings/feedbacklink.locstring.json';
import { helpLink } from 'owa-locstrings/lib/strings/helplink.locstring.json';
import { openAnotherMailbox } from 'owa-locstrings/lib/strings/openanothermailbox.locstring.json';
import { privacyLink } from 'owa-locstrings/lib/strings/privacylink.locstring.json';
import { reportCalendarAbuseLink } from 'owa-locstrings/lib/strings/reportcalendarabuselink.locstring.json';
import { termsLink } from 'owa-locstrings/lib/strings/termslink.locstring.json';
import { showModal } from 'owa-modal';
import { DEFAULT_COLLAPSED_WIDTH } from 'owa-search/lib/searchConstants';
import { getConfig } from 'owa-service/lib/config';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import { isConsumer } from 'owa-session-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { logCalendarUsage } from 'owa-shared-analytics';
import { isTimePanelAvailable } from 'owa-time-panel/lib/utils/isTimePanelAvailable';
import { isTodoPanelAvailable } from 'owa-todos/lib/utils/isTodoPanelAvailable';
import { getAccessTokenforResource } from 'owa-tokenprovider';
import { getNewScope } from 'owa-url';
import { lazyLaunchInAppFeedback } from 'owa-uservoice';
import OwaWorkload from 'owa-workloads/lib/store/schema/OwaWorkload';
import isWorkloadSupported from 'owa-workloads/lib/utils/isWorkloadSupported';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { dispatch } from 'satcheljs';
import { resolve as urlResolve } from 'url';
import {
    lazyOnHideNotificationReceived,
    lazyOnNotificationReceived,
    addChatTab,
    isSkypeInTabsEnabled,
} from 'owa-skype';
import {
    getCurrentThemeId,
    isUserPersonalizationAllowed,
    getHeaderImageData,
    getPaletteAsRawColors,
    getCobrandingThemeResources,
    OwaPalette,
    ThemeConstants,
} from 'owa-theme';
import {
    LinkClickEventArgs,
    SuiteHeader,
    NavBarData as ShellNavBarData,
    ShellLayout,
    CustomizationRegion,
    ShellControl,
    ThemeDataOverride,
    BaseTheme as ShellThemePalette,
    NavBarLinkData,
    SignOutEventArgs,
    FlexPaneChangeListenerProperties,
} from '@suiteux/suiteux-shell-react';
import {
    OwaGetStartedButton,
    OwaWhatsNewButton,
    OwaFeatureFlagsButton,
    OwaFeedbackButton,
    OwaSettingsButton,
    OwaShellHelpButton,
    OwaCustomHelpButton,
    OwaToDoButton,
    OwaBusinessChatButton,
    OwaConsumerChatButton,
    OwaDiagnosticsButton,
    OwaActivityFeedButton,
    OwaPremiumButton,
    OwaTimePanelButton,
} from './OwaSuiteHeaderButton';
import {
    OwaFeedbackFlexPane,
    OwaFeatureFlagsFlexPane,
    OwaSettingsFlexPane,
    OwaToDoFlexPane,
    OwaWhatsNewFlexPane,
    OwaGetStartedFlexPane,
    OwaHelpFlexPane,
    OwaTimePanelFlexPane,
    OwaActivityFeedFlexPane,
} from './OwaSuiteFlexPane';
import { isGetStartedInFlexPaneEnabled } from 'owa-get-started/lib/utils/isGetStartedInFlexPaneEnabled';

const headerStyles = require('./OwaSuiteHeader.scss');

export interface OwaSuiteHeaderProps {
    renderSearch?: () => React.ReactElement<{}>;
    searchAlignmentWidth?: number;
    DiagnosticsPanel?: React.ComponentType<{}>;
}

interface ExtendedWindow {
    O365Shell: IO365ShellShim;
}

declare var window: Window & ExtendedWindow;

const ShellMailId = 'ShellMail';

@observer
export default class OwaSuiteHeader extends React.Component<OwaSuiteHeaderProps, {}> {
    /**
     * When the UserThemeId is set to 'base', the Shell uses an AppBrandTheme palette, if provided.
     * This will be taken from the OWA theme definition with Id 'base'.
     */
    private readonly owaBrandTheme: ShellThemePalette;

    private readonly isMaxHelpPaneEnabled = isFeatureEnabled('help-o365ShellHeader-MaxPane');

    private readonly owaChatEnabled =
        !isFeatureEnabled('fwk-partner-code-off') &&
        !isFeatureEnabled('fwk-skypeSuite') &&
        (isFeatureEnabled('fwk-skypeBusiness') || isFeatureEnabled('fwk-skypeConsumer')) &&
        !getUserConfiguration().SessionSettings.IsShadowMailbox;

    private readonly headerChatEnabled =
        isFeatureEnabled('fwk-skypeSuite') &&
        (isFeatureEnabled('fwk-skypeBusiness') || isFeatureEnabled('fwk-skypeConsumer'));

    private readonly renderedCallback = () => owaSuiteHeaderRendered();

    constructor(props: OwaSuiteHeaderProps) {
        super(props);

        this.owaBrandTheme = this.createThemeData('base').UserThemePalette;
    }

    componentDidMount() {
        if (this.isMaxHelpPaneEnabled) {
            window.addEventListener('message', handleSocPostMessageEvents, false);
        }

        if (this.headerChatEnabled) {
            window.addEventListener('swc:core:ready', () => {
                this.onSwcCoreReady();
            });
        }
    }

    /**
     * Register for Skype notifications when SWC is initialized.
     *
     * @private
     * @memberof OwaSuiteHeader
     */
    private onSwcCoreReady(): void {
        window.removeEventListener('swc:core:ready', () => {
            this.onSwcCoreReady();
        });
        if (window.swc) {
            window.swc.API.registerEvent(
                'receivedNotification',
                lazyOnNotificationReceived.importAndExecute
            );
            window.swc.API.registerEvent(
                'hideNotification',
                lazyOnHideNotificationReceived.importAndExecute
            );

            if (isSkypeInTabsEnabled()) {
                // 1) Pass in ParallelView = false
                window.swc.API.registerEvent('ready', function() {
                    window.swc.shared.app.isParallelView = false;
                });

                // 2) Recents proxy
                window.swc
                    .getRecents()
                    .then(recentsProxy => recentsProxy.setOptions({ PreventOpenChat: true }));

                // 3) On recents selected
                window.swc.API.registerEvent('onRecentItemSelected', function(id: string) {
                    dispatch(addChatTab(id));
                });
            }
        }
    }

    componentWillUnmount() {
        if (this.isMaxHelpPaneEnabled) {
            window.removeEventListener('message', handleSocPostMessageEvents);
        }
    }

    render() {
        return (
            <div tabIndex={-1}>
                <SuiteHeader
                    onLinkClick={this.onLinkClick}
                    culture={getUserConfiguration().SessionSettings.UserCulture}
                    language={getUserConfiguration().SessionSettings.UserLanguage}
                    isRTL={getUserConfiguration().SessionSettings.IsUserCultureRightToLeft}
                    isConsumer={isConsumer()}
                    userDisplayName={getUserConfiguration().SessionSettings.UserDisplayName}
                    userPrincipalName={getUserConfiguration().SessionSettings.UserPrincipalName}
                    workloadID={'Exchange'}
                    appBrandTheme={this.owaBrandTheme}
                    currentMainLinkElementID={ShellMailId}
                    themeData={this.createThemeData()}
                    customLayout={this.createCustomLayout()}
                    meSublinks={this.createMeSublinks()}
                    shellAssetsContainerOverride={`${urlResolve(
                        getPackageBaseUrl(),
                        'resources/suiteux-shell'
                    )}`}
                    navBarData={this.getNavBarData()}
                    onSignOut={this.signout}
                    onFlexPaneVisibilityChanged={this.flexPaneVisiblityChanged}
                    shellDataOverrides={{
                        SuiteServiceUrl: `${window.location.origin}${
                            getConfig().baseUrl
                        }/service.svc`,
                        MAXHelpEnabled: this.isMaxHelpPaneEnabled,
                        HideMyProfileLink: getUserConfiguration().SessionSettings.IsShadowMailbox,
                        HideMyAccountLink: getUserConfiguration().SessionSettings.IsShadowMailbox,
                    }}
                    renderedCallback={this.renderedCallback}
                    getAccessTokenforResource={this.headerChatEnabled ? this.getToken : null}
                    disableToasts={true} // This will turn off suite header toasts
                    userID={getUserConfiguration().SessionSettings.UserPuid}
                />
            </div>
        );
    }

    /**
     * @ToDo : Please edit this method appropriately.
     *
     * @private
     * @param {string} resourceAudience
     * @returns {Promise<string>}
     * @memberof OwaSuiteHeader
     */
    private async getToken(resourceAudience: string): Promise<string> {
        return await getAccessTokenforResource(resourceAudience);
    }

    private onLinkClick = (data: LinkClickEventArgs) => {
        if (data && data.Id == 'Calendar') {
            logCalendarUsage('ModuleSwitchToCalendar', {
                source: 'mailWaffle',
            });
        }
    };

    private signout = (eventArgs: SignOutEventArgs) => {
        eventArgs.triggerEvent.preventDefault();
        signout(location);
    };

    private flexPaneVisiblityChanged = (
        isVisible: boolean,
        props: FlexPaneChangeListenerProperties
    ) => {
        setAppPaneUnderlayVisibility('suiteFlexPane', isVisible, true /* isShrinkable */);
    };

    private getNavBarData = (): ShellNavBarData | null => {
        const owaNavBarData: ShellNavBarData = getBposNavBarData() as ShellNavBarData;
        if (owaNavBarData) {
            const navBarData: ShellNavBarData = {
                ...owaNavBarData,
                CurrentMainLinkElementID: ShellMailId,
                ThemeDataOverride: this.createThemeData(),
                AppBrandTheme: this.owaBrandTheme,
                FeedbackLink: this.createHelpLink(
                    'OwaFeedbackLink',
                    loc(feedbackLink),
                    'javascript:void(0)',
                    () => {
                        lazyLaunchInAppFeedback.importAndExecute();
                        return false;
                    }
                ),
                HelpLink: this.createHelpLink(
                    'OwaHelpLink',
                    loc(helpLink),
                    'https://go.microsoft.com/fwlink/?linkid=853225'
                ),
                PrivacyLink: this.createHelpLink(
                    'OwaPrivacyLink',
                    loc(privacyLink),
                    'https://go.microsoft.com/fwlink/?linkId=521839'
                ),
                LegalLink: this.createHelpLink(
                    'OwaTermsLink',
                    loc(termsLink),
                    'https://www.microsoft.com/en-us/servicesagreement'
                ),
                CurrentWorkloadHelpSubLinks: this.getWorkloadHelpSublinks(
                    owaNavBarData.CurrentWorkloadHelpSubLinks
                ),
            };

            return navBarData;
        } else {
            return null;
        }
    };

    private getWorkloadHelpSublinks(originalLinks: NavBarLinkData[]): NavBarLinkData[] {
        if (isWorkloadSupported(OwaWorkload.Calendar)) {
            originalLinks = (originalLinks || []).concat([
                this.createHelpLink(
                    'OwaCalendarAbuseLink',
                    loc(reportCalendarAbuseLink),
                    'https://www.microsoft.com/concern/calendarabuse'
                ),
            ]);
        }

        return originalLinks;
    }

    private pushOnCondition(
        controlCollection: ShellControl[],
        control: ShellControl,
        condition?: boolean
    ) {
        if (condition === undefined || condition) {
            controlCollection.push(control);
        }
    }

    private createCustomLayout = (): ShellLayout => {
        const customHeaderButtons: ShellControl[] = [];
        const { renderSearch } = this.props;

        this.pushOnCondition(
            customHeaderButtons,
            isFeatureEnabled('fwk-skypeBusiness') ? OwaBusinessChatButton : OwaConsumerChatButton,
            this.owaChatEnabled
        );
        this.pushOnCondition(
            customHeaderButtons,
            { id: 'owaChatButton', nativeControlID: 'ChatIcon' } as ShellControl,
            this.headerChatEnabled
        );
        this.pushOnCondition(
            customHeaderButtons,
            OwaPremiumButton,
            getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox &&
                isFeatureEnabled('auth-leftNavPremiumUpsell') &&
                !getUserConfiguration().SessionSettings.IsShadowMailbox
        );
        this.pushOnCondition(customHeaderButtons, OwaToDoButton, isTodoPanelAvailable());
        this.pushOnCondition(customHeaderButtons, OwaTimePanelButton, isTimePanelAvailable());
        this.pushOnCondition(customHeaderButtons, OwaSettingsButton);
        this.pushOnCondition(
            customHeaderButtons,
            this.isMaxHelpPaneEnabled ? OwaShellHelpButton : OwaCustomHelpButton
        );
        this.pushOnCondition(
            customHeaderButtons,
            OwaFeedbackButton,
            isFeatureEnabled('fwk-feedbackCharm')
        );
        this.pushOnCondition(
            customHeaderButtons,
            OwaFeatureFlagsButton,
            isFeatureEnabled('fwk-devTools')
        );
        this.pushOnCondition(
            customHeaderButtons,
            OwaGetStartedButton,
            isGetStartedInFlexPaneEnabled()
        );
        this.pushOnCondition(
            customHeaderButtons,
            OwaWhatsNewButton,
            isFeatureEnabled('whatsNew-Pane')
        );

        this.pushOnCondition(
            customHeaderButtons,
            OwaActivityFeedButton,
            isFeatureEnabled('auth-activityFeed')
        );

        this.pushOnCondition(
            customHeaderButtons,
            OwaDiagnosticsButton(this.props.DiagnosticsPanel),
            isFeatureEnabled('fwk-devTools') && !!this.props.DiagnosticsPanel
        );

        // Now define responsive behavior for all the custom header buttons, with the
        // right-most one getting dropped first
        customHeaderButtons.forEach((control, index, array) => {
            if (!control.responsiveBehavior) {
                control.responsiveBehavior = {
                    responsivePriority: array.length - 1 - index + 2,
                    minimizeBehavior: 'overflow',
                    delayMinimize: false,
                };
            }
        });

        let leftCharms = [
            {
                id: 'owaBranding',
                nativeControlID: 'O365Branding',
            } as ShellControl,
        ];

        if (isFeatureEnabled('fwk-cobranding')) {
            leftCharms.unshift({
                id: 'tenantLogo',
                nativeControlID: 'TenantLogo',
            } as ShellControl);
        }

        const leftCharmsWidth =
            (this.props.searchAlignmentWidth ||
                getUserConfiguration().UserOptions.NavigationBarWidth) - 48; // Subtract the button width

        const layout = {
            enableResponsive: isFeatureEnabled('fwk-o365shellheader-responsive'),
            leftCustomizationRegion: {
                includeAppLauncher: true,
            },
            centerCustomizationRegion: {
                alignItems: 'center',
                flex: '1 0 auto',
                children: [
                    // Left aligned items
                    {
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        flex: `1 0 ${DEFAULT_COLLAPSED_WIDTH + leftCharmsWidth}px`,
                        children: [
                            {
                                children: leftCharms,
                                flex: `0 0 ${leftCharmsWidth}px`,
                            } as CustomizationRegion,
                            {
                                id: 'owaSearchBox',
                                flex: `1 0 ${DEFAULT_COLLAPSED_WIDTH}px`,
                                render: (container: HTMLDivElement) =>
                                    ReactDOM.render(
                                        <div className={headerStyles.searchContainer}>
                                            {renderSearch && renderSearch()}
                                        </div>,
                                        container
                                    ),
                                responsiveBehavior: {
                                    responsivePriority: 1,
                                    minimizeBehavior: 'none',
                                    responsiveSteps: [DEFAULT_COLLAPSED_WIDTH],
                                },
                            } as ShellControl,
                        ],
                    } as CustomizationRegion,

                    // Right aligned items
                    {
                        regionID: HEADER_BUTTONS_REGION_ID,
                        flex: '0 0 auto',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        children: [
                            ...customHeaderButtons,
                            {
                                id: 'OwaMergedNotificationPane',
                                render: (container: HTMLDivElement) =>
                                    ReactDOM.render(getMergedNotificationPane(), container),
                            } as ShellControl,
                        ],
                    } as CustomizationRegion,
                ],
            } as CustomizationRegion,
            rightCustomizationRegion: {
                includeMeControl: true,
            },
            flexPaneCollection: [
                OwaFeedbackFlexPane,
                OwaFeatureFlagsFlexPane,
                OwaSettingsFlexPane,
                OwaToDoFlexPane,
                OwaTimePanelFlexPane,
                OwaWhatsNewFlexPane,
                OwaGetStartedFlexPane,
                OwaHelpFlexPane,
                OwaActivityFeedFlexPane,
            ],
        } as ShellLayout;

        return layout;
    };

    private createThemeData = (themeId: string = getCurrentThemeId()): ThemeDataOverride => {
        const bgdImgData = getHeaderImageData(themeId);
        const themeData: ThemeDataOverride = {
            UserPersonalizationAllowed: isUserPersonalizationAllowed(),
            IsDarkTheme: getIsDarkTheme(),
            UserThemeId: themeId,
            PreferOfficeTheme: themeId === ThemeConstants.BASE_OFFICE_THEME_ID,
            UserThemePalette: {
                ...this.generateSuitePaletteFromFabricPalette(getPaletteAsRawColors(themeId)),
                BackgroundImageUrl: bgdImgData.primary,
                BackgroundImageRepeat: bgdImgData.repeat,
            },
            TenantThemePalette: isFeatureEnabled('fwk-cobranding')
                ? this.generateSuitePaletteFromFabricPalette(
                      getCobrandingThemeResources().themePalette
                  )
                : null,
        } as ThemeDataOverride;

        return themeData;
    };

    private generateSuitePaletteFromFabricPalette(palette: OwaPalette) {
        return {
            LighterAlt: palette.themeLighterAlt,
            Darker: palette.themeDarker,
            Dark: palette.themeDark,
            DarkAlt: palette.themeDarkAlt,
            Light: palette.themeLight,
            Primary: palette.themePrimary,
            Secondary: palette.themeSecondary,
            Tertiary: palette.themeTertiary,
            Lighter: palette.themeLighter,
            NavBar: palette.headerBackground,
            DefaultText: palette.headerTextIcons,
            DefaultBackground: palette.headerButtonsBackground,
            HoverBackground: palette.headerButtonsBackgroundHover,
            AppName: palette.headerBrandText,
            SearchNavBar: palette.headerBackgroundSearch,
            SearchHoverBackground: palette.headerButtonsBackgroundSearchHover,
            SearchAccent: palette.headerBadgeBackground,
        };
    }

    private createHelpLink = (
        id: string,
        helpText: string,
        url: string,
        action?: {}
    ): NavBarLinkData => {
        return {
            Id: id,
            Text: helpText,
            Url: url,
            TargetWindow: '_blank',
            Action: action,
        } as NavBarLinkData;
    };

    private createMeSublinks = (): NavBarLinkData[] => {
        return getUserConfiguration().SessionSettings.WebSessionType === WebSessionType.Business &&
            isFeatureEnabled('auth-openAnotherMailbox')
            ? [
                  {
                      Id: 'OwaOpenTargetMailboxLink',
                      Text: loc(openAnotherMailbox),
                      Url: 'javascript:void(0)',
                      Action: this.showOpenAnotherMailboxDialog,
                  },
              ]
            : [];
    };

    private showOpenAnotherMailboxDialog = () => {
        const [modalPromise] = showModal(OpenAnotherMailboxDialog);
        modalPromise.then(targetMailbox => {
            if (targetMailbox && targetMailbox.length > 0) {
                window.open(getNewScope(targetMailbox), '_blank');
            }
        });
    };
}
